import React from 'react';
import style from './style.module.scss';

type FormLabelProps = {
  model: string | undefined;
  brand: string | undefined;
};

const FormLabel: React.FC<FormLabelProps> = ({ model, brand }: FormLabelProps) => {
  const modelLowerCase = model?.toLowerCase();

  switch (modelLowerCase) {
    case 'c5':
      return (
        <>
          Чтобы стать обладателем кроссовера <span className={style.brand}>{brand}</span>{' '}
          {model}, вы можете разместить предзаказ онлайн.
        </>
      );
    case 'c7':
      return (
        <>
          Чтобы стать обладателем стильного кроссовер{' '}
          <span className={style.brand}>OMODA С7</span>, вы можете разместить предзаказ
          онлайн.
          <br />
          Мы наблюдаем повышенный интерес к автомобилям OMODA и даем возможность каждой
          семье стать частью нашей О-вселенной, поэтому для нас важно максимально
          эффективно распределить ресурсы для каждого клиента этого сообщества. В связи с
          этим, один клиент вправе забронировать только один автомобиль.
        </>
      );
    case 's5':
    case 's5 gt':
      return (
        <>
          Чтобы стать обладателем седана <span className={style.brand}>{brand}</span>{' '}
          {model}, вы можете разместить предзаказ онлайн.
        </>
      );
    case 'j7':
      return (
        <>
          Чтобы стать обладателем кроссовера&nbsp;
          <span className={style.brand}>
            {brand} {model}
          </span>
          , вы можете разместить предзаказ онлайн.
        </>
      );
    case 'j8':
      return (
        <>
          Чтобы стать обладателем флагманского кроссовера&nbsp;{' '}
          <span className={style.brand}>
            {brand} {model}
          </span>
          , вы можете разместить предзаказ онлайн.
        </>
      );
    default:
      return (
        <>
          Чтобы стать обладателем кроссовера OMODA С5, вы можете разместить предзаказ
          онлайн.
          <br />
          Мы наблюдаем повышенный интерес к автомобилям OMODA и даем возможность каждой
          семье стать частью нашей О-вселенной, поэтому для нас важно максимально
          эффективно распределить ресурсы для каждого клиента этого сообщества. В связи с
          этим, один клиент вправе забронировать только один автомобиль.
        </>
      );
  }
};

export default FormLabel;
